import React from 'react';
import Navigation from '../navigation';

const DropdownContainer: React.FC = () => {
    return (
      <div className='page-layout'>
        <Navigation/>
        <main className='main'>
          <div>Dropdown</div>
        </main>
      </div>
    );
  };
  
export default DropdownContainer;